/**
 * kv_simple componentData 字典与表格 draft 行之间的转换。
 */

/**
 * 将任意值规范为 plain string dict；数组/null/非对象 → {}。
 * :param {*} value: 原始 componentData 值
 * :returns {Object<string, string>}
 */
export function normalizeKvSimpleDict(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }
  const out = {};
  for (const [k, v] of Object.entries(value)) {
    out[k] = String(v ?? "");
  }
  return out;
}

/**
 * dict → 表格 draft 行。
 * :param {*} value: 原始 dict
 * :returns {{key: string, val: string}[]}
 */
export function dictToDraftRows(value) {
  return Object.entries(normalizeKvSimpleDict(value)).map(([key, val]) => ({
    key,
    val,
  }));
}

/**
 * draft 行 → dict；空 key 丢弃，重复 key 后者覆盖。
 * :param {{key?: string, val?: *}[]} rows: 表格行
 * :returns {Object<string, string>}
 */
export function draftRowsToDict(rows) {
  const out = {};
  for (const row of rows ?? []) {
    const key = row?.key ?? "";
    if (!key) continue;
    out[key] = String(row?.val ?? "");
  }
  return out;
}
